export type Locale = 'en-US' | 'ar-SA';
export type Direction = 'ltr' | 'rtl';

export interface LocaleMeta {
  locale: Locale;
  direction: Direction;
  label: string;
}

export const SUPPORTED_LOCALES: LocaleMeta[] = [
  { locale: 'en-US', direction: 'ltr', label: 'English' },
  { locale: 'ar-SA', direction: 'rtl', label: 'العربية' },
];

export const DEFAULT_LOCALE: Locale = 'en-US';

export function getDirection(locale: Locale): Direction {
  return locale === 'ar-SA' ? 'rtl' : 'ltr';
}

export function isRTL(locale: Locale): boolean {
  return getDirection(locale) === 'rtl';
}
